import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../../PredefinedPIXIAnchorPoint";
import data from "../configs/data";
import {Button} from "../controlElements/Button";
import {PixiApplication} from "../PixiApplication";

export class Info extends PIXI.Container {

    public static getInstance(): Info {
        if (!Info.OBJ_INSTANCE) {
            Info.OBJ_INSTANCE = new Info();
        }
        return Info.OBJ_INSTANCE;
    }

    private static OBJ_INSTANCE: Info;

    private page1: PIXI.Container;

    private readonly CLOSE_BUTTON_POSITION = new PIXI.Point(1124, 51);
    private readonly PAGE_1_POSITION = new PIXI.Point(640, 290);

    private FIRST_LINE_HEADER_POSITION = new PIXI.Point(375, 110);
    private FIRST_LINE_VALUE_POSITION = new PIXI.Point(806, 110);
    private readonly LINES_OFFSET = 43.1;

    private readonly HEADER_TEXT_STYLE = {
        fontSize: 19,
        fontFamily: "RobotoRegular",
        fill: "#ffffff",
    };

    private readonly VALUE_TEXT_STYLE = {
        fontSize: 19,
        fontFamily: "RobotoRegular",
        fill: "#ffff99",
    };

    private constructor() {
        super();

        this.createAndAddBackgroundBlend();
        this.createAndAddPage1Content();
        this.createAndAddCloseButton();
        this.close();
    }

    public open(): void {
        this.visible = true;
    }

    public close(): void {
        this.visible = false;
    }

    public toggleVisibility(): void {
        if (this.visible) {
            this.close();
        } else {
            this.open();
        }
    }

    private createAndAddPage1Content(): void {
        this.page1 = new PIXI.Container();
        const background = PIXI.Sprite.fromImage(data.images.infoBackground);
        background.interactive = true;
        background.position = this.PAGE_1_POSITION;
        background.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.page1.addChild(background);
        this.createAndAddPage1Text();

        this.createAndAddPageText([
            "Blackjack pays:",
                "Number of decks of cards used:",
                "Dealer hits or stands on soft 17:",
                "Player can double after split:",
                "Player can double on:",
                "Player can resplit to:",
                "Player can resplit aces:",
                "Player can hit split aces:",
                "Player loses only original bet against dealer BJ:",
                "Surrender rule:"],
            ["3 to 2",
                "8",
                "STANDS",
                "NO",
                "Any two cards",
                "4",
                "NO",
                "NO",
                "YES",
                "NONE"]);

        this.addChild(this.page1);
    }

    private createAndAddPage1Text(): void {
        const firstLineHeader = new PIXI.Text("Blackjack pays:", this.HEADER_TEXT_STYLE);
        firstLineHeader.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        firstLineHeader.position = this.FIRST_LINE_HEADER_POSITION;
        this.page1.addChild(firstLineHeader);
        (window as any).firstLineHeader = firstLineHeader;
        const firstLineValue = new PIXI.Text("3 to 2", this.VALUE_TEXT_STYLE);
        firstLineValue.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        firstLineValue.position = this.FIRST_LINE_VALUE_POSITION;
        this.page1.addChild(firstLineValue);
        (window as any).firstLineValue = firstLineValue;
    }

    private createAndAddPageText(headers: Array<string>, values: Array<string>): void {
        for (let i = 0; i < headers.length; i++) {
            const lineHeader = new PIXI.Text(headers[i], this.HEADER_TEXT_STYLE);
            lineHeader.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
            lineHeader.position = this.FIRST_LINE_HEADER_POSITION;
            lineHeader.position.y += i * this.LINES_OFFSET;
            this.page1.addChild(lineHeader);
            (window as any).firstLineHeader = lineHeader;
            const lineValue = new PIXI.Text(values[i], this.VALUE_TEXT_STYLE);
            lineValue.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
            lineValue.position = this.FIRST_LINE_VALUE_POSITION;
            lineValue.position.y += i * this.LINES_OFFSET;
            this.page1.addChild(lineValue);
        }
    }

    private createAndAddCloseButton(): void {
        const contentClose = new Button(data.images.infoAndHowToPlayCloseBase, data.images.infoAndHowToPlayCloseHover,
            data.images.infoAndHowToPlayCloseClick, data.images.infoAndHowToPlayCloseClick, data.audios.buttonClicked);
        contentClose.position = this.CLOSE_BUTTON_POSITION;
        contentClose.subscribeOnClicked(() => {
            this.close();
        });
        this.addChild(contentClose);
    }

    private createAndAddBackgroundBlend(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 0.3);
        graphics.drawRect(-PixiApplication.WIDTH / 2, -PixiApplication.HEIGHT / 2,
            PixiApplication.WIDTH, PixiApplication.HEIGHT);
        graphics.endFill();
        const backgroundBlend = new PIXI.Sprite(graphics.generateCanvasTexture());
        backgroundBlend.position.x = PixiApplication.WIDTH / 2;
        backgroundBlend.position.y = PixiApplication.HEIGHT / 2;
        backgroundBlend.anchor = PredefinedPIXIAnchorPoint.CENTER;
        backgroundBlend.interactive = true;
        this.addChild(backgroundBlend);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/Info.ts